import { PubSub } from '@aws-amplify/pubsub';
import { Subscriber, Observable, ReplaySubject, Subject } from "rxjs";
import { delay, finalize, take } from "rxjs/operators";
import { federatedSignIn, getCurrentUser } from '../Auth';
import { ProcessType } from "../types";

const DISCONNECT_MGS = "Disconnected, error code: 8";
export const endpoint = process.env.REACT_APP_BE_BACKEND_FOR_FRONTEND_ENDPOINT;

export const setEventStream = (observer: Subscriber<any>, endpoint: string) => {
  const eventSource = new EventSource(endpoint);
  const errorMsg = `GET ${endpoint} net::ERR_CONNECTION_REFUSED`;
  eventSource.onmessage = x => observer.next(x);
  eventSource.onerror = x => observer.error(new Error(errorMsg));
  return () => {
    eventSource.close();
  };
};
export const setPubsubStream = (observer: Subscriber<any>, processType: ProcessType | string) => {
  const { factory } = getCurrentUser();
  const endpoint = `${factory}/${processType}`;
  const sub = PubSub.subscribe(endpoint, { qos: 1 }).subscribe({
    next: ({ value }) => observer.next(value),
    error: ({ error }) => {
      if (error === DISCONNECT_MGS) {
        federatedSignIn();
      }
    },
    ...observer
  });
  return () => {
    sub.unsubscribe();
  }
};

export const errorHandler = <T>(errors: Observable<T>): Observable<T> => {
  const delayRetryConnection = 3000; // 3sec
  const numberOfReconnectionAttempts = 10;
  return errors.pipe(
    delay(delayRetryConnection),
    take(numberOfReconnectionAttempts)
  )
};

export const shareSubjectWithDelay = <T>(observable: Observable<T>, withReplay = true): Observable<T> => {
  const wait = 1000; // 1sec
  const subject = withReplay ? new ReplaySubject<T>() : new Subject<T>();
  const data = observable.subscribe(subject);

  return subject.pipe(
    finalize(() => setTimeout(() => data.unsubscribe(), wait))
  );
};